








import {Vue, Prop , Component} from 'vue-property-decorator';
@Component
export default class FormFormatRow extends Vue{
    @Prop() columnCount?: number;
    @Prop() rowIndex?: number;
    
}
